import { MedosClient } from "../client/MedosClient";
import { ENDPOINTS } from "../constants/endpoints";
import { toWireChannel } from "../types/otpChannel";
function toWireBody(payload) {
    return payload.channel === "email"
        ? { channel: toWireChannel("email"), email: payload.email }
        : {
            channel: toWireChannel("phone"),
            countryCode: payload.countryCode,
            phoneNumber: payload.phoneNumber,
        };
}
const PatientService = {
    async sendPhoneVerificationOtp(payload) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.patients.sendPhoneVerificationOtp, toWireBody(payload));
        return res.data;
    },
    async verifyPhoneVerificationOtp(payload) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.patients.verifyPhoneVerificationOtp, { ...toWireBody(payload), otpCode: payload.otpCode });
        return res.data;
    },
    async searchByPhone(countryCode, phoneNumber) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.get("/patients/search-by-phone", {
            params: { countryCode, phoneNumber },
        });
        return res.data;
    },
};
export { PatientService, };
